import { isMobile } from './index';

const mediaQuery = `
@media screen and (max-width: 667px) {
   ul li{
     margin:0 1rem 0 0;
    }
 }

 @media screen and (max-width: 361px) {
    .ul li:active button, .ul li:visited button, .ul li:hover button, ul li button{
        font-size:0.8rem;
    }
 }

 @media screen and (max-width: 321px) {
    .ul li:active button, .ul li:visited button, .ul li:hover button, ul li button{
        font-size:0.7rem;
    }
 }
}
`;

const screenSizes = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '428px',
  mobileXL: '480px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const screenTypes = {
  mobileS: `(max-width: ${screenSizes.mobileS})`,
  mobileM: `(max-width: ${screenSizes.mobileM})`,
  mobileL: `(max-width: ${screenSizes.mobileL})`,
  mobileXL: `(max-width: ${screenSizes.mobileXL})`,
  tablet: `(max-width: ${screenSizes.tablet})`,
  laptop: `(max-width: ${screenSizes.laptop})`,
  laptopL: `(max-width: ${screenSizes.laptopL})`,
  desktop: `(max-width: ${screenSizes.desktop})`,
  desktopL: `(max-width: ${screenSizes.desktop})`,
  mobileMedia: `${mediaQuery}`,
};

const DESKTOP = 'desktop';
const MOBILE = 'mobile';

const SMALL = 'small';
const LARGE = 'large';

export const getListGroupViewPort = () => (isMobile() ? MOBILE : DESKTOP);
export const getSizeByDevice = () => (isMobile() ? SMALL : LARGE);
